import { render } from "./AdminPasswords.vue?vue&type=template&id=3456c380"
import script from "./AdminPasswords.vue?vue&type=script&lang=js"
export * from "./AdminPasswords.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__